module.exports = __webpack_public_path__ + "static/media/card2.6b85465d.jpg";